<div class="merge-tag-picker" role="dialog" aria-label="Merge tag picker">
	<div class="merge-tag-picker__header" data-merge-tag-drag-handle="true">
		<mat-form-field class="merge-tag-picker__search no-hint" appearance="fill">
			<mat-label>{{ resolvedConfig.searchPlaceholder }}</mat-label>
			<input #searchInput matInput type="text" [formControl]="searchControl" autocomplete="off" />
			<button
				type="button"
				mat-icon-button
				matSuffix
				*ngIf="searchTerm"
				aria-label="Clear search"
				(click)="searchControl.setValue('')"
			>
				<mat-icon>close</mat-icon>
			</button>
		</mat-form-field>

		<button type="button" mat-icon-button class="merge-tag-picker__close" aria-label="Close merge tag picker" (click)="onClose()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="merge-tag-picker__body" *ngIf="!isInvalidData; else invalidState">
		<div class="merge-tag-picker__empty" *ngIf="noResults">
			{{ resolvedConfig.noResultsLabel }}
		</div>

		<div class="merge-tag-picker__empty" *ngIf="!noResults && !visibleTree.length">
			No merge tags available
		</div>

		<div class="merge-tag-picker__tree" *ngIf="visibleTree.length">
			<app-merge-tag-tree-node
				*ngFor="let node of visibleTree"
				[node]="node"
				[expanded]="isPathExpanded(node.path)"
				[expandedPaths]="expandedPaths"
				[showExample]="resolvedConfig.showExampleValues"
				(toggle)="onToggleNode($event.path, $event.expanded)"
				(select)="onSelectNode($event)"
			></app-merge-tag-tree-node>
		</div>
	</div>

	<ng-template #invalidState>
		<div class="merge-tag-picker__empty">
			{{ errorMessage || resolvedConfig.invalidDataLabel }}
		</div>
	</ng-template>
</div>
